import type { BookingStatus } from '@/api/schemas';

export const STATUS_TEXT: Record<BookingStatus, string> = {
  confirmed: 'Подтверждена',
  arrived: 'Машина в работе',
  ready: 'Готово — можно забирать',
  completed: 'Завершена',
  cancelled: 'Отменена',
  no_show: 'Неявка',
};

export const STATUS_DOT: Record<BookingStatus, 'success' | 'warning' | 'error' | 'accent' | 'neutral'> = {
  confirmed: 'accent',
  arrived: 'warning',
  ready: 'success',
  completed: 'neutral',
  cancelled: 'error',
  no_show: 'error',
};
